<template>
    <div>
        <p class="text-primary subtitle mt-48" style="margin-bottom:8px;">{{ $t('listing_form.remaining_details.floor_plan_images') }}</p>
        <div class="d-flex flex-wrap minimal-container-row position-relative">
            <template v-if="items.length">
                <uploader :listing_id="listing_id" type="floor_plans" :upload_files="$t('listing_form.remaining_details.upload_floor_plans')" :upload_more_files="$t('listing_form.remaining_details.upload_floor_plans')" class="photo-component media-uploader-small__container"></uploader> 
                <div class="photo-component" v-for="photo in items" :key="photo.id">
                    <template v-if="photo.is_uploading">
                        <div class="photo-component__uploading photo-component__wrap">
                            <div class="photo-component__upload-progress">
                                <div class="photo-component__upload-progress__bar">
                                    <div class="photo-component__upload-progress__current" :style="{width: photo.progress + '%'}"></div>
                                </div>
                                <p class="text-center subtitle text-secondary">
                                    <template v-if="photo.progress < 100">Uploading...</template>
                                    <template v-else>Compressing photo</template>
                                </p>
                            </div>
                        </div>
                        <p class="text-primary">{{photo.name}}</p>
                    </template>
                    <template v-else-if="photo.is_uploaded">
                        <div class="photo-component__wrap">
                            <img :src="getThumbnail(photo)" :alt="photo.name">
                            <div class="photo-component__buttons">
                                <a @click="previewPhoto(photo)" class="button button-m button-outline-white preview-photo-desktop photo-component__button-center">{{ $t('common.preview') }}</a>
                                <a @click="previewPhoto(photo)" class="text-white subtitle preview-photo-mobile photo-component__button-center">{{ $t('common.preview') }}</a>
                                <a @click="deletePhoto(photo.id)" class="delete"><img src="/img/bin.svg" alt="delete"></a>
                            </div>
                        </div>
                        <p class="text-primary">{{photo.name}}</p>
                    </template>
                    <template v-else>
                        <div class="photo-component__alert">
                            <div class="photo-component__alert__triangle">
                                <img src="/img/alert-triangle.svg" alt="alert">
                            </div>
                            <p class="text-center subtitle text-alert">Unable to upload file, please try again.</p>
                        </div>
                        <p class="text-alert">{{photo.name}}</p>
                    </template>
                </div>
            </template>
            <template v-else>
                <div class="media-uploader-large">
                    <uploader :listing_id="listing_id" type="floor_plans" :upload_files="$t('listing_form.remaining_details.upload_floor_plans')" :upload_more_files="$t('listing_form.remaining_details.upload_floor_plans')" class="media-uploader-large__container" :is_large="true"></uploader>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            listing_id: Number
        },
        data() {
            return {
                items: [],
                is_loaded: false,
            }
        },
        methods: {
            previewPhoto(photo) {
                this.$root.$emit('preview_photo', photo);
            },
            deletePhoto(id) {
                this.$root.$emit('show_confirmation', {
                    'title': this.$t('common.remove_photo'),
                    'description': this.$t('common.are_you_sure'),
                    'type': DELETE_FLOOR_PLANS_PHOTO,
                    'data': {
                        'id': id
                    },
                    'button_text': this.$t('common.remove')
                });
            },
            appendUploadedPhotos(data) {
                this.items = this.items.concat(data);
            },
            getFloorPlans() {
                let url =  `/api/photos/get-floor-plans/${this.listing_id}`;

                return axios.get(url)
                    // get data
                    .then(function (response) {
                        // handle success
                        this.items = response.data.data.photos;
                        this.is_loaded = true;
                    }.bind(this));
            },
            updateUploadProgress(data) {
                let index = this.items.findIndex(item => item.id === data.id);

                if (index !== -1) {
                    this.$set(this.items[index], 'progress', data.progress)
                } else {
                    this.items = this.items.concat(data);
                }
            },
            getThumbnail(photo) {
                return photo.thumb_path ? photo.thumb_path : photo.full_path;
            },
        },
        mounted() {
            this.getFloorPlans()
            this.$root.$on('uploading_photo', (type, data) => {
                if (type == 'floor_plans') {
                    this.updateUploadProgress(data);
                }
            })
            this.$root.$on('uploaded_photo', (type, data, id) => {
                if (type == 'floor_plans') {
                    let index = this.items.findIndex(item => item.id === id);

                    if (index !== -1) {
                        this.$set(this.items[index], 'is_uploading', false)

                        Object.keys(data).forEach(function(key) {
                            this.$set(this.items[index], key, data[key])
                        }.bind(this));
                    } else {
                        this.items = this.items.concat(data);
                    }
                }
                // this.refresh_sort = true;
            })
            
            this.$root.$on('deleted_photo', (type, id) => {
                if (type == 'floor_plans') {
                    this.items.splice(this.items.findIndex(item => item.id === id), 1)
                }
            })

            this.$root.$on('confirmed', (type, data) => {
                console.log('confirmed')
                if (type == DELETE_FLOOR_PLANS_PHOTO) {
                    let url =  `/api/photos/delete/${this.listing_id}`;

                    axios.delete(url, {data : {id: data.id}}).then(function (response) {
                        console.log('deleted');
                    }).then(function(response) {
                        this.items.splice(this.items.findIndex(item => item.id === data.id), 1)
                    }.bind(this));
                }
            })
        }
    }
</script>
